import React from 'react';
import { motion } from 'framer-motion';
import { Play, Star } from 'lucide-react';

const videos = [
  {
    id: 1,
    client: 'Alok Home',
    project: 'Residential Interior - Ranchi',
    video: '/videos/project1.mp4',
    duration: '2:15',
    rating: 5,
  },
  {
    id: 2,
    client: 'Purwanchal Apartment',
    project: 'Luxury Interior - Greater Noida',
    video: '/videos/project2.mp4',
    duration: '1:45',
    rating: 5,
  },
  {
    id: 3,
    client: 'Modern Living Space',
    project: 'Full Interior Design',
    video: '/videos/project3.mp4',
    duration: '3:20',
    rating: 5,
  },
  {
    id: 4,
    client: 'Restaurant Interior',
    project: 'Commercial Interior Design',
    video: '/videos/project4.mp4',
    duration: '2:50',
    rating: 5,
  },
];

export default function VideoTestimonials() {
  return (
    <section className="py-24 md:py-32 bg-[#2C2C2C]">
      <div className="max-w-7xl mx-auto px-6 md:px-16">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-12 h-[1px] bg-[#C9A962]" />
            <span className="text-[#C9A962] tracking-[0.3em] text-xs uppercase">Video Stories</span>
            <div className="w-12 h-[1px] bg-[#C9A962]" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-white mb-4">
            What Our Clients Say
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto text-lg">
            Short videos from our clients — quick reactions and project walk-throughs.
          </p>
        </motion.div>

        {/* Video Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {videos.map((video, index) => (
            <motion.div
              key={video.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group cursor-pointer"
            >
              {/* Video Thumbnail */}
              <div className="relative overflow-hidden mb-4 aspect-[9/12] bg-white/5">
                <video
                  src={video.video}
                  className="w-full h-full object-cover"
                  muted
                  loop
                  playsInline
                  autoPlay
                />
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-[#2C2C2C]/40 group-hover:bg-[#2C2C2C]/60 transition-colors duration-300" />
                
                {/* Play Button */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-16 bg-[#C9A962] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <Play className="w-6 h-6 text-white ml-1" fill="white" />
                  </div>
                </div>

                {/* Duration Badge */}
                <div className="absolute top-4 right-4 bg-[#2C2C2C]/80 backdrop-blur-sm text-white text-xs px-2 py-1">
                  {video.duration}
                </div>

                {/* Rating */}
                <div className="absolute bottom-4 left-4 flex gap-1">
                  {[...Array(video.rating)].map((_, i) => (
                    <Star key={i} className="w-3 h-3 fill-[#C9A962] text-[#C9A962]" />
                  ))}
                </div>
              </div>

              {/* Info */}
              <div>
                <h3 className="text-white font-serif text-lg mb-1 group-hover:text-[#C9A962] transition-colors">
                  {video.client}
                </h3>
                <p className="text-white/50 text-sm">
                  {video.project}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="text-white/60 text-sm mb-4">
            Want to share your experience? We'd love to feature your story!
          </p>
          <a
            href="#contact"
            className="inline-flex items-center text-[#C9A962] border border-[#C9A962] px-6 py-3 hover:bg-[#C9A962] hover:text-white transition-all"
          >
            Get In Touch
          </a>
        </motion.div>
      </div>
    </section>
  );
}